import { useRef } from 'react'
import type ReactECharts from 'echarts-for-react'
import { useEconomicSectorData } from '../../../hooks/useEconomicSectorData'
import EconomicSectorChart from '../../../chart/EconomicSectorChart'
import { RiskProfileCard } from '../../RiskProfileCard'
import { ChartQueryState } from '../../ChartQueryState'
import { ChartExportActions } from '../../../chart/ChartExportActions'
import { useExportXlsx } from '../../../hooks/useExportXlsx'
import { useExportChartImage } from '../../../hooks/useExportChartImage'
import type {
  PropertiesQueryParams,
  PropertiesMetricOption,
} from '../../../types/riskProfileProperties.types'

export interface EconomicSectorWidgetProps {
  queryParams: PropertiesQueryParams | null
  metricOption: PropertiesMetricOption
  entityNoun: string
}

export function EconomicSectorWidget({
  queryParams,
  metricOption,
  entityNoun,
}: EconomicSectorWidgetProps) {
  const { request, query } = useEconomicSectorData(queryParams)
  const { exportXlsx, isExporting } = useExportXlsx(request, '/report/risk-profile/properties/xlsx')
  const chartRef = useRef<ReactECharts>(null)
  const handleExportImage = useExportChartImage(chartRef, `${entityNoun}-disrupted-by-sector`)

  return (
    <RiskProfileCard
      title="Risk of disruption by sector"
      description="Risk of disruption by sector."
      onExport={
        <ChartExportActions
          onExportXlsx={exportXlsx}
          onExportImage={handleExportImage}
          isExportingXlsx={isExporting}
          xlsxDisabled={!request}
        />
      }
      className="min-h-96"
    >
      <ChartQueryState query={query}>
        {(data) => (
          <EconomicSectorChart
            ref={chartRef}
            data={data}
            metricOption={metricOption}
            entityNoun={entityNoun}
          />
        )}
      </ChartQueryState>
    </RiskProfileCard>
  )
}
